export function valueToPercent(r,n,e){return 100*(r-n)/(e-n)}export function range(r,n){const e=n-r+1;return Array.from({length:e},((n,e)=>e+r))}